import { Base, BaseProps, AppearanceTypes } from 'components/Shared/Layout/base';
import styles from './styles.scss';
import cn from 'classnames';

export const Main = ({ className, ...base }: BaseProps<AppearanceTypes>) => (
  <Base {...base} className={cn(styles.main, className)} type="div" />
);
